// extracted by mini-css-extract-plugin
export default {"container":"J9vgegy7mzkGEc96xw0w","trigger":"TsAViOjbioFLtPlFf932","triggerText":"paz_F5C8WP2HP3OEoqDQ","dropdown":"uiPeHTldWU5f6UFg2tEA","dropdownOpen":"Ujr3MOULcQzPEa4_shtJ"};